import service from '@/services';

const downloadMultipleFiles = async (alias: string, files: HistoryFile[]) => {
  for (const [index, file] of files.entries()) {
    const data = await service.export.getDonwloadBlob(alias, index);
    if (data) {
      const href = URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', file.name);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    }
  }
};

const exportUtils = {
  downloadMultipleFiles,
};

export default exportUtils;
